<template>
  <div class="context-header row">
    <div v-for="(value, name) in fields" class="col-sm-4">
      <b>{{name}}:</b> {{value}}
    </div>
  </div>
</template>
<script>
  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      fields() {
        return this.$ncsCsvElementFields(this.document, this.text, this.elements, this.matches)
      }
    }
  }
</script>